import React from "react";
import { AlertTriangleIcon, BrainIcon, CameraIcon, ClockIcon, HelpCircleIcon, SearchIcon } from "lucide-react";
import { situations, SituationIcon } from "../../data/content";
import { CTAButton } from "../CTAButton";
const iconMap: Record<SituationIcon, React.ElementType> = {
  alert: AlertTriangleIcon,
  clock: ClockIcon,
  help: HelpCircleIcon,
  camera: CameraIcon,
  search: SearchIcon,
  brain: BrainIcon
};
export function Situations() {
  return <section className="bg-sand px-4 py-16" data-id="element-246" data-mp="2jf1wb2bpgfl2">
      <div className="mx-auto max-w-3xl" data-id="element-247" data-mp="2ei1y1dl3kh4i">
        <h2 className="text-center font-serif text-[30px] font-bold leading-tight text-ink sm:text-4xl" data-id="element-248" data-mp="2ekfu9prijzdn">
          Do any of these situations sound familiar?
        </h2>
        <p className="mt-3 text-center text-[17px] text-muted" data-id="element-249" data-mp="25iyfqbtr85r2">
          If you answer <strong className="text-ink" data-id="element-250" data-mp="8pmykl05qlct">YES</strong> to any of these, I created this system for you.
        </p>

        <ul className="mt-8 space-y-3" data-id="element-251" data-mp="3rbny821g6tj">
          {situations.map(s => {
          const Icon = iconMap[s.icon];
          return <li key={s.text} className="flex gap-4 rounded-2xl bg-white p-4 sm:p-5" data-id="element-252" data-mp="137g29xwcvwo4">
                <span className="flex h-11 w-11 shrink-0 items-center justify-center rounded-xl bg-ink text-goldsoft" data-id="element-253" data-mp="1823hf65gzeq1">
                  <Icon className="h-5 w-5" aria-hidden data-id="element-254" data-mp="z3i2dkz7ihu0" />
                </span>
                <p className="text-[16px] leading-snug text-ink" data-id="element-255" data-mp="z5m53zlddasp">{s.text}</p>
              </li>;
        })}
        </ul>

        <div className="mt-10 space-y-3 text-center text-[17px] leading-relaxed text-ink" data-id="element-256" data-mp="1quft4ji0jscu">
          <p className="font-serif text-[24px] font-bold" data-id="element-257" data-mp="1d3at3gaqgy1z">And it shouldn’t have to feel so disorganized.</p>
          <p data-id="element-258" data-mp="1i241iub5xyva">Because the problem isn’t necessarily your experience.</p>
          <p data-id="element-259" data-mp="1i014hqblf5h2">
            The problem is that most professionals were never given a{" "}
            <strong data-id="element-260" data-mp="25pvgk5o38q09">repeatable framework</strong> for systematically reviewing what happened in a revision case.
          </p>
          <p className="pt-2 text-muted" data-id="element-261" data-mp="2kenb55ycnmi8">You don’t need another massive collection of theory.</p>
          <p className="text-[19px] font-bold" data-id="element-262" data-mp="2ffkikkzk38r5">You need a better way to organize the information you already have.</p>
        </div>

        <CTAButton className="mt-10" label="I want a structured revision system" data-id="element-263" data-mp="2afobudzh537w" />
      </div>
    </section>;
}